import {
    Component,
    OnDestroy,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { ListColumnDirective } from "@components/list/list-column.directive";
import { ListComponent } from "@components/list/list.component";
import _ from "lodash";
import { Subject, combineLatest } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { TradslagDTO } from "~app/features/virkeskop/models/mbf-models";
import { AtgardSkogsvardTradslag } from "~app/features/virkeskop/models/skogsvard/skogsvard-models";
import { SkogsvardForyngringService } from "~app/features/virkeskop/services/skogsvard-foryngring.service";
import { SkogsvardService } from "~app/features/virkeskop/services/skogsvard.service";

@Component({
    selector: "rask-skogsvard-detaljer-mb-for",
    templateUrl: "./skogsvard-detaljer-mb-for.component.html",
    styleUrls: ["./skogsvard-detaljer-mb-for.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ListComponent,
        ListColumnDirective
    ]
})
export class SkogsvardDetaljerMbForComponent implements OnInit, OnDestroy {
    protected skogsvardForyngring: any[] = [];

    private readonly ngDestroyed$ = new Subject<void>();
    private readonly skogsvardForyngringService = inject(SkogsvardForyngringService);
    private readonly skogsvardService = inject(SkogsvardService);

    private allatradslag: TradslagDTO[];
    private skogsvardTradslagLista: AtgardSkogsvardTradslag[] = [];

    ngOnDestroy(): void {
        this.ngDestroyed$.next();
        this.ngDestroyed$.complete();
    }

    ngOnInit(): void {
        combineLatest([
            this.skogsvardForyngringService.skogsvardForyngringTradslag$,
            this.skogsvardService.getTradslag()
        ]
        ).pipe(takeUntil(this.ngDestroyed$))
            .subscribe({
                next: x => {
                    this.skogsvardTradslagLista = x[0];
                    this.allatradslag = x[1];
                    this.mapForyngring();
                },
                error: () => {
                //
                }
            });
    }

    private mapForyngring(): void {
        this.skogsvardForyngring.splice(0);
        this.skogsvardTradslagLista
            .forEach(x => {
                const frogiva = x?.frogiva ?? 0.32;
                const tradslag = this.allatradslag.find(t => t.id === x.tradslagId);
                const arealHa = this.skogsvardForyngringService.getArealHa(x);
                const malFrogiva = _.round(arealHa * frogiva, 2);
                this.skogsvardForyngring
                    .push({
                        id: tradslag?.id,
                        sekvensnummer: tradslag?.sekvensnummer,
                        tradslag: tradslag?.externkod,
                        malFrogiva: malFrogiva,
                        antalHa: arealHa,
                        frogiva: frogiva
                    });
            });

        this.skogsvardForyngring = [...this.skogsvardForyngring];
    }
}
